module.exports = __webpack_public_path__ + "static/media/twi.14d86d3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/twi.png
// module id = 25
// module chunks = 0